// extracted by mini-css-extract-plugin
export default {"button":"QuickfinderButton-0Fogm__button","favorites-icon":"QuickfinderButton-62g1f__favorites-icon","menu-icon":"QuickfinderButton-lpG6C__menu-icon"};